import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import KakobuyUltimateGuide from "@/pages/article/kakobuy-spreadsheet-ultimate-guide/page";
import CSSBuyComparison from "@/pages/article/cssbuy-vs-kakobuy-comparison/page";
import SuperbuyGuide from "@/pages/article/superbuy-spreadsheet-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/kakobuy-spreadsheet-ultimate-guide",
    element: <KakobuyUltimateGuide />,
  },
  {
    path: "/article/cssbuy-vs-kakobuy-comparison",
    element: <CSSBuyComparison />,
  },
  {
    path: "/article/superbuy-spreadsheet-guide",
    element: <SuperbuyGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;